export default __webpack_public_path__ + "static/media/linkedin-icon.feb290bd.svg";